import './SingleAccordion.scss';

import { useRef } from 'react';

import arrowdown from 'common-modules/general/assets/Mobile/images/common/ico_down_arrow.png';
import arrowup from 'common-modules/general/assets/Mobile/images/common/ico_up_arrow.png';

interface Props {
  containerRef: React.RefObject<HTMLDivElement>;
  accordionKey: string;
  title: React.ReactNode;
  content: React.ReactNode;
  selectedAccordionKey: string;

  setSelectedAccordionKey(key: string): void;
}

const SingleAccordion = ({
  containerRef,
  accordionKey,
  selectedAccordionKey,
  title,
  content,
  setSelectedAccordionKey
}: Props) => {
  const scrollToAccordionContainer = () => {
    window.scrollTo({ behavior: 'smooth', top: (containerRef.current?.offsetTop || 0) - 40 });
  };

  const handleAccordionClick = (key: string) => {
    scrollToAccordionContainer();

    if (key !== selectedAccordionKey) {
      setSelectedAccordionKey(key);
    } else {
      setSelectedAccordionKey('');
    }
  };

  const isActive = accordionKey === selectedAccordionKey;

  return (
    <div className="accordion-wrap type02">
      <button className="switch-btn" type="button" onClick={() => handleAccordionClick(accordionKey)}>
        <span className="txt">{title}</span>
        <span className="arrow">{isActive ? <img src={arrowup} alt="" /> : <img src={arrowdown} alt="" />}</span>
      </button>
      <div className={`${isActive ? 'open' : 'close'} accordion-contents`}>
        <div className="container">{content}</div>
      </div>
    </div>
  );
};

export default SingleAccordion;
